export default class BackLogisticsList {
    userCode: string;
    warehouseName: string;
    receiveStatus: number;
    orderNumber: number;
    shipment: string;
    reMark: string;
    rejectionTime?: Date;
    createTime: Date;
    signForTime?: Date;
    orderUserCode: string;
    id: number;
    imageGuid: string;
    goodsImageGuid: string;
    userUploadImageGuid: string;
    shelfNumber: string;
    isConfirm: boolean;
    isNeedTakePicture: boolean;
    phone: string;
    selectShipmentEnd: string;
    signUserName: string;
    orderType: number;
    storeId?: number;
    storeName: string;
}